<template>
  <div class="equipment-modal-backdrop" @click.self="$emit('close')" style="position: fixed; top: 0; left: 0; right: 0; bottom: 0; width: 100vw; height: 100vh; background: rgba(30,40,60,0.92); z-index: 999999; display: flex; justify-content: center; align-items: center; padding: 20px; overflow-y: auto;">
    <div class="equipment-modal-content" style="background: #fff; border-radius: 20px; max-width: 900px; width: 100%; max-height: 90vh; overflow: hidden; box-shadow: 0 20px 60px rgba(0,0,0,0.4); position: relative; display: flex; flex-direction: column;">
      <button class="equipment-modal-close" @click="$emit('close')" style="position: absolute; top: 16px; right: 20px; background: #fff; border: none; width: 44px; height: 44px; border-radius: 50%; font-size: 28px; color: #1a4c8a; cursor: pointer; z-index: 10; display: flex; align-items: center; justify-content: center; box-shadow: 0 4px 12px rgba(0,0,0,0.2);">×</button>
      
      <!-- Основное изображение -->
      <div v-if="image" class="modal-image">
        <img :src="image" :alt="machine.name" @error="onImageError" />
      </div>

      <div class="modal-body" style="padding: 40px 50px;">
        <!-- Информация о станке -->
        <div class="modal-info">
          <h2 class="modal-title">{{ machine.name }}</h2>
          <p class="modal-description">{{ machine.description }}</p>

          <!-- Технические характеристики -->
          <div v-if="machine.specs && machine.specs.length" class="modal-specs">
            <div class="specs-title">Технические характеристики</div>
            <div class="specs-list">
              <div v-for="(spec, index) in machine.specs" :key="index" class="specs-list-row" :class="{ 'with-divider': index !== machine.specs.length - 1 }">
                <span class="spec-label">{{ spec.name }}</span>
                <span class="spec-value">{{ spec.value }}</span>
              </div>
            </div>
          </div>

          <!-- Возможности -->
          <div v-if="machine.capabilities && machine.capabilities.length" class="modal-capabilities">
            <div class="capabilities-title">Возможности</div>
            <ul class="capabilities-list">
              <li v-for="(capability, index) in machine.capabilities" :key="index">
                <span class="capability-dot"></span>{{ capability }}
              </li>
            </ul>
          </div>

          <!-- Особенности -->
          <div v-if="machine.features && machine.features.length" class="modal-features">
            <div class="features-title">Особенности</div>
            <ul class="features-list">
              <li v-for="(feature, index) in machine.features" :key="index">
                {{ feature }}
              </li>
            </ul>
          </div>

          <!-- Применение -->
          <div v-if="machine.applications && machine.applications.length" class="modal-applications">
            <div class="applications-title">Применение</div>
            <ul class="applications-list">
              <li v-for="(application, index) in machine.applications" :key="index">
                <span class="application-icon">→</span>{{ application }}
              </li>
            </ul>
          </div>
        </div>

        <!-- Галерея дополнительных фото -->
        <div v-if="machine.media && machine.media.length" class="media-gallery">
          <div class="section-title">
            Фотогалерея
          </div>
          <swiper
            :modules="modules"
            :slides-per-view="1"
            :space-between="10"
            :navigation="true"
            :pagination="{ clickable: true }"
            :breakpoints="{
              640: { slidesPerView: 2 },
              1024: { slidesPerView: 3 }
            }"
            class="media-swiper"
          >
            <swiper-slide v-for="(photo, index) in machine.media" :key="index">
              <div class="gallery-item" @click="openLightbox(photo)">
                <img :src="photo" :alt="`Фото ${index + 1}`" />
                <div class="gallery-overlay">
                  <span class="zoom-icon">🔍</span>
                </div>
              </div>
            </swiper-slide>
          </swiper>
        </div>

        <!-- Видео -->
        <div v-if="machine.videos && machine.videos.length" class="videos-section">
          <div class="section-title">
            Видео работы оборудования
          </div>
          <div class="videos-grid">
            <div v-for="(video, index) in machine.videos" :key="index" class="video-item">
              <div class="video-title">{{ video.title }}</div>
              <!-- YouTube видео -->
              <div v-if="video.type === 'youtube'" class="video-container">
                <iframe
                  :src="video.url"
                  frameborder="0"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                  allowfullscreen
                  class="video-iframe"
                ></iframe>
              </div>
              <!-- MP4 / Local видео -->
              <div v-else-if="video.type === 'mp4' || video.type === 'local'" class="video-container">
                <video controls class="video-player">
                  <source :src="video.url" type="video/mp4">
                  Ваш браузер не поддерживает воспроизведение видео.
                </video>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Lightbox для просмотра фото -->
    <div v-if="lightboxImage" class="lightbox" @click="closeLightbox">
      <button class="lightbox-close" @click="closeLightbox">×</button>
      <img :src="lightboxImage" alt="Увеличенное фото" class="lightbox-image" @click.stop />
    </div>
  </div>
</template>

<script>
import { Swiper, SwiperSlide } from 'swiper/vue'
import { Navigation, Pagination } from 'swiper/modules'
import 'swiper/css'
import 'swiper/css/navigation'
import 'swiper/css/pagination'

export default {
  name: 'EquipmentDetailModal',
  components: {
    Swiper,
    SwiperSlide
  },
  props: {
    machine: { type: Object, required: true },
    image: { type: String, required: true }
  },
  data() {
    return {
      lightboxImage: null,
      modules: [Navigation, Pagination]
    }
  },
  methods: {
    openLightbox(imageUrl) {
      this.lightboxImage = imageUrl
    },
    closeLightbox() {
      this.lightboxImage = null
    },
    onImageError(event) {
      console.error('Ошибка загрузки изображения:', event.target.src)
    }
  }
}
</script>

<style>
.equipment-modal-backdrop {
  position: fixed !important;
  top: 0 !important;
  left: 0 !important;
  right: 0 !important;
  bottom: 0 !important;
  background: rgba(30,40,60,0.85);
  backdrop-filter: blur(4px);
  z-index: 99999 !important;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 20px;
  overflow-y: auto;
}

.equipment-modal-content {
  background: #fff;
  border-radius: 20px;
  max-width: 900px;
  width: 100%;
  max-height: 90vh;
  overflow: hidden;
  box-shadow: 0 20px 60px rgba(26,76,138,0.25);
  position: relative;
  animation: equipmentModalIn 0.3s cubic-bezier(.48,.15,.36,1.23);
  display: flex;
  flex-direction: column;
  margin: auto;
}

@keyframes equipmentModalIn {
  from { transform: scale(0.9) translateY(50px); opacity: 0; }
  to { transform: scale(1) translateY(0); opacity: 1; }
}

.equipment-modal-close {
  position: absolute;
  top: 16px;
  right: 20px;
  background: rgba(255,255,255,0.95);
  border: none;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  font-size: 2rem;
  color: #1a4c8a;
  cursor: pointer;
  z-index: 10;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 4px 12px rgba(0,0,0,0.15);
  transition: all 0.3s;
}

.modal-close:hover {
  background: #fff;
  transform: rotate(90deg);
}

.modal-image {
  width: 100%;
  height: 280px;
  background: linear-gradient(135deg, #f7faff 0%, #e8f1ff 100%);
  display: flex;
  align-items: center;
  justify-content: center;
  border-top-left-radius: 20px;
  border-top-right-radius: 20px;
  overflow: hidden;
  position: relative;
  padding: 10px;
  flex-shrink: 0;
}

.modal-image img {
  max-width: 100%;
  max-height: 100%;
  width: auto;
  height: auto;
  object-fit: contain;
}

.modal-body {
  padding: 40px 50px;
  flex: 1;
  overflow-y: auto;
}

.modal-info {
  margin-bottom: 30px;
}

.modal-title {
  font-weight: 900;
  margin-bottom: 14px;
  color: var(--primary-color);
  font-size: 1.75rem;
  line-height: 1.3;
}

.modal-description {
  color: #5a6c7d;
  margin-bottom: 24px;
  line-height: 1.7;
  font-size: 1.05rem;
}

.specs-title {
  font-size: 1.15rem;
  font-weight: 700;
  margin-bottom: 12px;
  color: var(--primary-color);
  display: flex;
  align-items: center;
  gap: 8px;
}

.specs-list {
  background: #f8fafc;
  border-radius: 12px;
  padding: 16px;
  margin-bottom: 20px;
}

.specs-list-row {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  padding: 10px 0;
  font-size: 1rem;
  line-height: 1.5;
}

.specs-list-row.with-divider {
  border-bottom: 1px dashed #d1dce5;
}

.spec-label {
  color: #1a4c8a;
  font-weight: 700;
  min-width: 140px;
  text-align: left;
  padding-right: 15px;
  flex-shrink: 0;
}

.spec-value {
  color: #2d3748;
  text-align: right;
  flex: 1;
  word-break: break-word;
}

.capabilities-title {
  font-size: 1.15rem;
  font-weight: 700;
  margin-bottom: 12px;
  color: var(--primary-color);
}

.capabilities-list {
  list-style: none;
  padding-left: 0;
  margin-bottom: 0;
}

.capabilities-list li {
  margin-bottom: 12px;
  color: #2d3748;
  font-size: 1rem;
  display: flex;
  align-items: flex-start;
  line-height: 1.6;
}

.capability-dot {
  display: inline-block;
  width: 8px;
  height: 8px;
  background: linear-gradient(135deg, #3a7bd5 0%, #1a4c8a 100%);
  border-radius: 50%;
  margin-right: 12px;
  margin-top: 6px;
  flex-shrink: 0;
}

/* Особенности */
.modal-features {
  margin-top: 24px;
}

.features-title {
  font-size: 1.15rem;
  font-weight: 700;
  margin-bottom: 12px;
  color: var(--primary-color);
}

.features-list {
  list-style: disc;
  padding-left: 24px;
  margin-bottom: 0;
  background: #f0f7ff;
  border-radius: 12px;
  padding: 16px 16px 16px 40px;
}

.features-list li {
  margin-bottom: 8px;
  color: #2d3748;
  font-size: 0.95rem;
  line-height: 1.6;
}

.features-list li:last-child {
  margin-bottom: 0;
}

.features-list li::marker {
  color: var(--primary-color);
}

/* Применение */
.modal-applications {
  margin-top: 24px;
}

.applications-title {
  font-size: 1.15rem;
  font-weight: 700;
  margin-bottom: 12px;
  color: var(--primary-color);
}

.applications-list {
  list-style: none;
  padding-left: 0;
  margin-bottom: 0;
  background: #fff7ed;
  border-radius: 12px;
  padding: 16px;
}

.applications-list li {
  margin-bottom: 10px;
  color: #2d3748;
  font-size: 0.95rem;
  display: flex;
  align-items: flex-start;
  line-height: 1.6;
}

.applications-list li:last-child {
  margin-bottom: 0;
}

.application-icon {
  display: inline-block;
  color: #f59e0b;
  font-weight: 700;
  font-size: 1rem;
  margin-right: 10px;
  flex-shrink: 0;
}

/* Секции с заголовками */
.section-title {
  font-size: 1.35rem;
  font-weight: 700;
  color: var(--primary-color);
  margin-bottom: 20px;
  padding-bottom: 12px;
  border-bottom: 3px solid #e8f1ff;
}

.section-title::after {
  display: none !important;
}

/* Галерея медиа */
.media-gallery {
  margin-bottom: 35px;
}

.media-swiper {
  border-radius: 12px;
  overflow: visible;
  padding: 10px 0 40px 0;
}

.gallery-item {
  position: relative;
  border-radius: 12px;
  overflow: hidden;
  cursor: pointer;
  height: 200px;
  transition: transform 0.3s;
}

.gallery-item:hover {
  transform: translateY(-5px);
}

.gallery-item img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}

.gallery-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(26, 76, 138, 0.8);
  display: flex;
  align-items: center;
  justify-content: center;
  opacity: 0;
  transition: opacity 0.3s;
}

.gallery-item:hover .gallery-overlay {
  opacity: 1;
}

.zoom-icon {
  font-size: 2.5rem;
  filter: drop-shadow(0 2px 4px rgba(0,0,0,0.3));
}

/* Видео секция */
.videos-section {
  margin-bottom: 20px;
}

.videos-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 24px;
}

.video-item {
  background: #f8fafc;
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 4px 12px rgba(0,0,0,0.08);
}

.video-title {
  padding: 14px 18px;
  font-weight: 700;
  color: var(--primary-color);
  font-size: 1.05rem;
  background: linear-gradient(135deg, #e8f1ff 0%, #f0f6ff 100%);
  border-bottom: 2px solid #d1dce5;
}

.video-container {
  position: relative;
  padding-bottom: 56.25%; /* 16:9 aspect ratio */
  height: 0;
  overflow: hidden;
}

.video-iframe,
.video-player {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  border: none;
}

.video-player {
  background: #000;
}

/* Lightbox */
.lightbox {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.95);
  z-index: 10000;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
  animation: fadeIn 0.3s;
}

@keyframes fadeIn {
  from { opacity: 0; }
  to { opacity: 1; }
}

.lightbox-close {
  position: absolute;
  top: 20px;
  right: 20px;
  background: rgba(255,255,255,0.9);
  border: none;
  width: 50px;
  height: 50px;
  border-radius: 50%;
  font-size: 2.5rem;
  color: #1a4c8a;
  cursor: pointer;
  z-index: 10001;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.3s;
}

.lightbox-close:hover {
  background: #fff;
  transform: rotate(90deg) scale(1.1);
}

.lightbox-image {
  max-width: 90%;
  max-height: 90%;
  object-fit: contain;
  border-radius: 8px;
  box-shadow: 0 20px 60px rgba(0,0,0,0.5);
}

/* Swiper стили */
:deep(.swiper-button-next),
:deep(.swiper-button-prev) {
  color: var(--primary-color) !important;
  background: rgba(255,255,255,0.95);
  width: 40px;
  height: 40px;
  border-radius: 50%;
  box-shadow: 0 4px 12px rgba(0,0,0,0.15);
}

:deep(.swiper-button-next:after),
:deep(.swiper-button-prev:after) {
  font-size: 18px;
  font-weight: 900;
  color: var(--primary-color) !important;
}

:deep(.swiper-pagination-bullet) {
  background: var(--primary-color);
  opacity: 0.4;
  width: 10px;
  height: 10px;
}

:deep(.swiper-pagination-bullet-active) {
  opacity: 1;
  background: var(--primary-color);
}

/* Адаптивность */
@media (max-width: 768px) {
  .modal-content {
    max-width: 100%;
    max-height: 95vh;
    border-radius: 16px;
  }

  .modal-body {
    padding: 20px;
  }

  .modal-title {
    font-size: 1.4rem;
  }

  .modal-image {
    height: 200px;
  }

  .section-title {
    font-size: 1.15rem;
  }

  .videos-grid {
    grid-template-columns: 1fr;
  }

  .gallery-item {
    height: 150px;
  }

  .spec-label {
    min-width: 100px;
    font-size: 0.9rem;
  }

  .spec-value {
    font-size: 0.9rem;
  }
}

@media (max-width: 480px) {
  .modal-backdrop {
    padding: 10px;
  }

  .modal-close {
    width: 35px;
    height: 35px;
    font-size: 1.5rem;
    top: 10px;
    right: 10px;
  }

  .modal-title {
    font-size: 1.2rem;
  }

  .modal-description {
    font-size: 0.95rem;
  }
}
</style>
